import ResourcesIcon from '@mui/icons-material/TipsAndUpdatesOutlined';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { useSelector } from 'react-redux';

import SectionTitle from '@/components/SectionTitle/SectionTitle';
import Tutorial from '@/components/Tutorial';
import { tutorialsData, tutorialsDataChile } from '@/constants/resources';
import usePageTitle from '@/hooks/usePageTitle';
import { RootState } from '@/redux/store';

const Resources = () => {
  usePageTitle('Recursos');

  const { profile } = useSelector((state: RootState) => state.parcel);
  const country = profile.data?.country;

  if (!country) return null;

  const tutorials = country === 'CHL' ? tutorialsDataChile : tutorialsData;

  return (
    <Container maxWidth="xxl">
      <SectionTitle title="Recursos" mt={5}>
        <ResourcesIcon fontSize="large" />
      </SectionTitle>

      <Paper
        elevation={3}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          alignItems: 'center',
          justifyContent: 'center',
          p: { xs: 2, sm: 4 },
        }}
      >
        <Grid container spacing={3}>
          {tutorials.map((tutorial) => (
            <Grid
              key={tutorial.title}
              size={{ xs: 12, sm: 6, md: 4 }}
              display="flex"
              justifyContent="center"
            >
              <Tutorial
                title={tutorial.title}
                text={tutorial.text}
                videoUrl={tutorial.videoUrl}
                pdfUrl={tutorial.pdfUrl}
              />
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Container>
  );
};

export default Resources;
